import {HookMiddleware} from '../react';
import {BaseEntity, LoadingState, State} from './types';

export function fetchMiddleware<S extends State<T>, Actions, T extends BaseEntity>(callback: () => any): HookMiddleware<S, Actions> {
	return (store: State<T>) => {
		if (store.loadingState === LoadingState.None) {
			callback();
		}
	};
}